import { EntityContext, EntityOperation, FormMode } from '@msdk/definitions'

import { FormCustomActionArgs } from './custom-action-args'
import { CustomActionBase } from './custom-action-base'

export abstract class FormCustomAction extends CustomActionBase {
  protected entity: EntityContext
  protected save: () => Promise<EntityOperation>

  protected readonly mode: FormMode
  protected readonly navigate: (url: string, sitemap?: string, additionalCtx?: Record<string, string>) => void
  protected readonly reloadEntity: () => Promise<void>
  protected readonly rebindEntity: (entity: EntityContext, pendingChanges?: boolean) => void

  constructor(args: FormCustomActionArgs) {
    super(args)
    this.entity = args.entity
    this.mode = args.mode
    this.navigate = args.navigate
    this.save = args.save
    this.reloadEntity = args.reloadEntity
    this.rebindEntity = args.rebindEntity
  }

  public updateEntity(newEntity: EntityContext) {
    this.entity = newEntity
  }

  public updateSave(newSave: () => Promise<EntityOperation>) {
    this.save = newSave
  }
}
